module.exports = __webpack_public_path__ + "static/img/20.061e6a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/20.jpg
// module id = o4YZ
// module chunks = 1